import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBPickupStatus = Database["public"]["Enums"]["pickup_status"];

export const PickupStatus = {
	PENDING: "pending",
	APPROVED: "approved",
	PENDING_REMOVAL: "pending_removal",
} as const satisfies Record<string, DBPickupStatus>;

export type PickupStatus = (typeof PickupStatus)[keyof typeof PickupStatus];

type _EnsureAllDBValues = Exclude<DBPickupStatus, PickupStatus> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const PICKUP_STATUSES = Object.values(PickupStatus) as readonly PickupStatus[];

export const pickupStatusSchema = z.enum(PickupStatus);

export const PICKUP_STATUS_LABELS: Record<PickupStatus, string> = {
	pending: "Pending",
	approved: "Approved",
	pending_removal: "Removal requested",
};
